'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherAlertTriangle, FeatherLoader } from '@subframe/core';
import { Button, LogoArbitralis } from '@/shared/components/ui';
import type { UseOnboardingSelfReturn } from '../hooks';
interface CriandoContaScreenProps {
  vm: UseOnboardingSelfReturn;
}
export const CriandoContaScreen = t0 => {
  const $ = _c(26);
  const {
    vm
  } = t0;
  if (vm.criarContaErro) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <LogoArbitralis className="flex-none opacity-60 [&_img]:h-6 [&_img]:w-auto" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="bg-error-100 flex h-14 w-14 items-center justify-center rounded-full"><FeatherAlertTriangle className="text-error-700 text-2xl" /></div>;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <h1 className="text-heading-dark text-xl font-semibold">Não conseguimos criar sua conta</h1>;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    let t4;
    if ($[3] !== vm.criarContaErro.mensagem) {
      t4 = <div className="flex max-w-[420px] flex-col items-center gap-2 text-center">{t3}<p className="text-label-muted text-sm leading-relaxed" role="alert">{vm.criarContaErro.mensagem}</p></div>;
      $[3] = vm.criarContaErro.mensagem;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    let t5;
    if ($[5] !== vm.acaoErroCriacao || $[6] !== vm.irParaLogin) {
      t5 = vm.acaoErroCriacao === "acessarConta" && <Button size="medium" onClick={vm.irParaLogin}>Acessar minha conta</Button>;
      $[5] = vm.acaoErroCriacao;
      $[6] = vm.irParaLogin;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    let t6;
    if ($[8] !== vm.acaoErroCriacao || $[9] !== vm.criandoConta || $[10] !== vm.repetirCriacaoConta) {
      t6 = vm.acaoErroCriacao === "tentarNovamente" && <Button size="medium" loading={vm.criandoConta} onClick={vm.repetirCriacaoConta}>Tentar novamente</Button>;
      $[8] = vm.acaoErroCriacao;
      $[9] = vm.criandoConta;
      $[10] = vm.repetirCriacaoConta;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== vm.voltarDoErroDeCriacao) {
      t7 = <Button variant="neutral-secondary" size="medium" onClick={vm.voltarDoErroDeCriacao}>Revisar meus dados</Button>;
      $[12] = vm.voltarDoErroDeCriacao;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    let t8;
    if ($[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
      t8 = <div className="flex flex-wrap justify-center gap-2.5">{t5}{t6}{t7}</div>;
      $[14] = t5;
      $[15] = t6;
      $[16] = t7;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    let t9;
    if ($[18] !== t4 || $[19] !== t8) {
      t9 = <div className="flex min-h-screen w-full flex-col items-center justify-center gap-7 bg-white px-6 py-12">{t1}{t2}{t4}{t8}</div>;
      $[18] = t4;
      $[19] = t8;
      $[20] = t9;
    } else {
      t9 = $[20];
    }
    return t9;
  }
  let t1;
  let t2;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LogoArbitralis className="flex-none opacity-60 [&_img]:h-6 [&_img]:w-auto" />;
    t2 = <FeatherLoader className="text-brand-600 animate-spin text-[32px]" />;
    $[21] = t1;
    $[22] = t2;
  } else {
    t1 = $[21];
    t2 = $[22];
  }
  let t3;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="text-heading-dark text-xl font-semibold" role="status">Criando o espaço da sua empresa</span>;
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  let t4;
  if ($[24] !== vm.razaoCurta) {
    t4 = <div className="flex min-h-screen w-full flex-col items-center justify-center gap-7 bg-white px-6 py-12" aria-busy="true">{t1}{t2}<div className="flex max-w-[420px] flex-col items-center gap-2 text-center">{t3}<span className="text-label-muted text-sm leading-relaxed">{vm.razaoCurta} · configurando produtos, permissões e saldo inicial.</span></div></div>;
    $[24] = vm.razaoCurta;
    $[25] = t4;
  } else {
    t4 = $[25];
  }
  return t4;
};